import React, { useEffect, useRef, useState } from "react";
import { useLocationConfiguration } from "../../LocationConfiguration";
import { ResourceDWR } from "../../../dto/ResourceDWR";
import { Button } from "@mui/material";
import axios from "axios";
import { getISBNList } from "@tlc/ls2pac/app/utils/PACStandardNumberUtil";

export interface TeachingBooksData {
  enabled: boolean;
  link: string;
  ltiMessageType: string;
  ltiVersion: string;
  oauthCallback: string;
  oauthConsumerKey: string;
  oauthNOnce: string;
  oauthSignature: string;
  oauthSignatureMethod: string;
  oauthTimestamp: string;
  oauthVersion: string;
}

export interface TeachingBooksButtonProps {
  resource: ResourceDWR;
  logoType?: "vertical" | "horizontal";
}

export const TeachingBooksButton: React.FC<TeachingBooksButtonProps> = ({
  resource,
  logoType = "horizontal",
}) => {
  const { locationConfiguration } = useLocationConfiguration();

  if (!locationConfiguration?.pacSettings.useTeachingBooks) {
    return null;
  }

  const [teachingBooksTitleId, setTeachingBooksTitleId] = useState(null);

  useEffect(() => {
    // request teaching books title id
    const getTeachingBooksId = async () => {
      const isbns = getISBNList(resource.standardNumbers);
      try {
        // TODO create a context to cache these responses if fairly static
        const { data } = await axios.post<number | null>(
          `/teachingBooks/titleId`,
          isbns,
        );

        setTeachingBooksTitleId(data);
      } catch (e) {
        console.log("error getting teaching books title id");
      }
    };

    getTeachingBooksId();
  }, [resource.id]);

  const onClickTeachingBooks = async () => {
    if (!teachingBooksTitleId) return;

    const targetWindowName = `teachingBooksWindow_${Date.now()}`;
    const newWindow = window.open("", targetWindowName);

    try {
      const { data } = await axios.get<TeachingBooksData>(
        `/teachingBooks/formData/${teachingBooksTitleId}`,
      );

      const form = document.createElement("form");
      form.method = "POST";
      form.action = data.link;
      form.target = targetWindowName;

      const fields: Record<string, string> = {
        oauth_callback: data.oauthCallback,
        oauth_consumer_key: data.oauthConsumerKey,
        oauth_nonce: data.oauthNOnce,
        oauth_signature: data.oauthSignature,
        oauth_signature_method: data.oauthSignatureMethod,
        oauth_timestamp: data.oauthTimestamp,
        oauth_version: data.oauthVersion,
        lti_version: data.ltiVersion,
        lti_message_type: data.ltiMessageType,
      };

      Object.entries(fields).forEach(([name, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    } catch (e) {
      newWindow?.close();
      console.error("error fetching teaching books form data");
    }
  };

  return (
    teachingBooksTitleId && (
      <>
        {/* TODO move .teachingBooksLink button styles here */}
        <Button aria-label="TeachingBooks" onClick={onClickTeachingBooks}>
          {/* 300px w x 73px h */}
          <img
            height={logoType === "vertical" ? "48px" : "36px"}
            src={
              logoType === "vertical"
                ? "images/logo-teachingbooks-vertical.png"
                : "images/logo-teachingbooks.png"
            }
            alt="TeachingBooks"
          />
        </Button>
      </>
    )
  );
};
